var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstHalfOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29.86,
    r: 12.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29.86,
    r: 17.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 2.68,
    width: 12,
    height: 5.8,
    rx: 2.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.98,
    y1: 12.66,
    x2: 21.98,
    y2: 8.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.02,
    y1: 12.66,
    x2: 28.02,
    y2: 8.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.07,
    y: 11.91,
    width: 8.01,
    height: 3.87,
    rx: 1.51,
    transform: "translate(21.82 -24.99) rotate(45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.31,
    y1: 15.76,
    x2: 38.07,
    y2: 14.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.16,
    y1: 18.61,
    x2: 40.92,
    y2: 16.86,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.92,
    y: 11.91,
    width: 8.01,
    height: 3.87,
    rx: 1.51,
    transform: "translate(25.02 17.33) rotate(135)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.69,
    y1: 15.76,
    x2: 11.93,
    y2: 14.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.84,
    y1: 18.61,
    x2: 9.08,
    y2: 16.86,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(15.64 35.58)",
    style: {
      fontSize: "13.674092292785645px",
      fontFamily: "Rubik-SemiBold, Rubik",
      fontWeight: 600
    }
  }, "15"), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,21.33a8.8,8.8,0,0,1,8.8,8.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstHalfOver);
export default __webpack_public_path__ + "static/media/FIRST_HALF_OVER.28e96e6bc014ac9fdebadf27bc35e3c1.svg";
export { ForwardRef as ReactComponent };